<template>
    <div>
         <headerNav title="保存银行卡" />
        <div class="smain">
            <van-form @submit="save">
                <div class="smain-list">
                    <van-field v-model="model.fullName" label="开户姓名" placeholder="请输入开户姓名" required :rules="[{ required: true, message: '请填写开户姓名' }]"/>
                    <!-- 输入手机号，调起手机号键盘 -->
                    <van-field v-model="model.openAccountBank" type="text" label="开户银行" placeholder="请输入开户银行" required  :rules="[{ required: true, message: '请填写开户银行' }]"/>
                    <van-field v-model="model.cardNo" type="tel" label="银行卡号" placeholder="请输入银行卡号" required  :rules="[{ required: true, message: '请填写银行卡号' }]"/>
                    <van-cell center title="是否默认">
                        <template #right-icon>
                            <van-switch v-model="model.isDefault" size="24" :active-color="$abctheme.basecolor" inactive-color="#dedede" />
                        </template>
                    </van-cell>
                </div>
                <van-button class="btn setbtns" round block native-type="submit" :color="$abctheme.basecolor">保存</van-button>
            </van-form>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            checked:false,
            model:{}
        }
    },
    created(){
        var option=this.$route.params;
        if(option.item)
        {
            this.model=option.item;
        }
    },
    methods:{
        save()
        {
            this.ajax.put('/api/services/app/PhoneUser/UpdateAndCreateBank',this.model).then(()=>
            {
                this.$toast('保存成功');
                this.$router.go(-1);
            });
        }
    }
}
</script>
<style lang="scss" scoped>
    .smain
    {
        margin: 10px;
        font-size: 12px;
    }
    .smain-list
    {
        padding: 10px;
        border-radius: 4px;
        background-color: #fff;
        box-shadow: 1px 1px 4px #dcdcdc;
        word-break: break-all;
    }
    .btn{
        margin-top: 20px;
        background-color: red;
        color:white;
    }
</style>